import { FC } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import palette from '../../theme/palette';
import AllieImg from '../../assets/images/about/IMG_2215.jpeg';
import VetraReady from '../../assets/images/about/IMG_8870.jpeg';
import VetraSweet from '../../assets/images/about/IMG_3092.jpeg';
import FamilyImg from '../../assets/images/xmas-mals.jpg';
import ScrollToTop from '../utils/ScrollToTop';
import NutritionCert from '../../assets/images/Nutrition_Cert.png';
import Holistic from '../../assets/images/Holistic.png';

export const About: FC = () => {
  return (
    <>
      <ScrollToTop />
      <Grid container>
        <Grid
          item
          container
          sx={{
            marginTop: '70px',
            backgroundColor: palette.gray,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              color: palette.text.contrast,
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 'bold', padding: { xs: '16px', md: '50px' } }}
            >
              Hi! My name is Allie Dellosa
            </Typography>
            <Typography variant="h6" sx={{ padding: { xs: '16px', md: '50px' } }}>
              and I am the owner of Rogue K9 Academy. I am a{' '}
              <span style={{ fontWeight: 'bold' }}>Certified Foundation Style Dog Trainer </span>
              and have been working with and training animals for 30 years. My passion is{' '}
              <span style={{ fontWeight: 'bold' }}>
                teaching people how to work with their strong temperament and/or aggressive dogs,
                without vilifying them
              </span>
              .
            </Typography>
          </Grid>
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <img
              src={AllieImg}
              alt="Allie Dellosa"
              style={{
                width: '100%',
                maxWidth: '400px',
                aspectRatio: '1 / 1',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          sx={{
            backgroundColor: palette.paper.secondary,
            display: 'flex',
            alignItems: 'center',
            padding: { xs: '16px', md: '50px' },
          }}
        >
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: 'column',
              color: palette.text.contrast,
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Certified Foundation Style Dog Training Through K9-1 Specialized Dog Training in New
              York
            </Typography>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Typography variant="h5" sx={{ padding: { xs: '16px', md: '50px' } }}>
            High drive, strong temperament, and aggressive dogs deserve respect, and the ability to
            enjoy their training. This is best accomplished by owners learning how to be the trainer
            and provider their dogs desire and need.
          </Typography>
        </Grid>
        <Grid
          item
          container
          spacing={4}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            minHeight: { xs: '1000px', md: '50vh' },
            pb: 5,
          }}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src={VetraReady}
              alt="Dog training - Vetra Ready"
              sx={{
                width: '100%',
                maxHeight: { xs: 'auto', md: '50vh' },
                objectFit: 'contain',
              }}
            />
          </Grid>

          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src={VetraSweet}
              alt="Dog training - Vetra Sweet"
              sx={{
                width: '100%',
                maxHeight: { xs: 'auto', md: '50vh' },
                objectFit: 'contain',
              }}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          sx={{
            backgroundColor: palette.paper.secondary,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'stretch',
          }}
        >
          <Grid
            item
            sm={12}
            md={5}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: { xs: '16px', md: '50px' },
              color: palette.text.contrast,
            }}
          >
            <Typography variant="h5" sx={{ lineHeight: 1.6 }}>
              At Rogue K9 Academy we take the whole family, canine genetics, your goals, and the
              issues at hand into consideration, we then create a training plan that makes sense and
              teach you how to achieve it with your dog(s). You will be able to practice training in
              beginning to advanced environments, with fun and exciting opportunities our strong
              tempered and/or aggressive dogs are often left out of.
            </Typography>
          </Grid>
          <Grid
            item
            sm={12}
            md={7}
            sx={{
              width: '100%',
              maxHeight: { xs: 'auto', md: '50vh' },
              minHeight: {
                xs: '400px',
                sm: '600px',
                md: '600px',
                lg: '700px',
              },
              objectFit: 'contain',
              backgroundImage: `url(${FamilyImg})`, // linear-gradient(to top, ${palette.paper.secondaryTransparent}, ${palette.paper.secondaryTransparent}),
              backgroundSize: 'cover',
              backgroundPosition: {
                xs: 'center',
                sm: 'top',
              },
              backgroundRepeat: 'no-repeat',
            }}
          />
        </Grid>
        <Grid item md={12}>
          <Typography variant="h5" sx={{ padding: { xs: '16px', md: '50px' } }}>
            <span style={{ fontWeight: 600 }}>Foundation Style Dog Training</span> is hack-free
            training that seeks to cultivate deep, meaningful, and working relationships between the
            handler and canine, resulting in: you becoming a confident dog-handler who truly
            understands their dog, and the dog being confident in their ability to meet the
            expectations set for them, with complete trust that their human has their best interests
            at heart.
          </Typography>
          <Typography variant="h5" sx={{ padding: { md: '50px' }, fontStyle: 'italic' }}>
            To learn more about FSDT, and my journey with it, see our{' '}
            <Link to="/philosophy">Philosophy</Link>!
          </Typography>
        </Grid>
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          sx={{ padding: { xs: '16px', md: '50px' } }}
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '800px',
                aspectRatio: '16 / 9',
                margin: '0 auto',
                mb: '20px',
              }}
            >
              <Box
                component="iframe"
                src="https://www.youtube.com/embed/-vDBns5hlyk"
                title="Meet Your Trainer"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0,
                  borderRadius: '10px',
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" sx={{ ml: 2 }}>
              I am fully committed to your success, and offer a hands-on approach. I belong to a
              mentorship program, and believe in always continuing my education to become better,
              not just in relation to dog training, but in canine nutrition and in disease
              prevention. We meet weekly to discuss cases, support each other, and hold ourselves
              accountable to a higher standard in this un-standardized industry. I am constantly
              learning more about how to better help our dogs, so that I can continue to offer my
              very best to each family that trusts me to be a part of their journey.
            </Typography>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Typography variant="h5" sx={{ padding: { xs: '16px', md: '50px' } }} />
        </Grid>
        <Grid item md={12}>
          <Typography
            variant="h4"
            sx={{
              padding: { xs: '16px', md: '50px' },
              color: palette.paper.secondary,
              fontWeight: 800,
            }}
          >
            Beyond Training, I am Certified in:
          </Typography>
        </Grid>
        <Grid
          item
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: 800, textAlign: 'center', marginBottom: '20px' }}
            >
              Small Animal Nutrition
            </Typography>
            <img
              src={NutritionCert}
              alt="Nutrition Certificate"
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </Grid>
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: { xs: '16px', md: '50px' },
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: 800, textAlign: 'center', marginBottom: '20px' }}
            >
              Cold Laser Therapy
            </Typography>
            <img
              src={Holistic}
              alt="Cold Laser Therapy"
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default About;
